import { takeLatest, put, call } from 'redux-saga/effects';
import { storage, path } from '@commons';
import {
  NEW_FILTER_CONTA_AGRARE,
  NEW_FILTER_CONTA_AGRARE_PEDING,
  NEW_FILTER_CONTA_AGRARE_SUCCESS,
  NEW_FILTER_CONTA_AGRARE_FAILURE,
} from '@handler';
import {
  CONST_FILTER_CONTA_AGRARE,
  CONST_ROWS_PER_PAGE,
} from '@commons/consts';
import { formatDateDDMMYYYY, formatDateYYYYMMDD } from '@components/common/format';
import { listContaAgrare } from './listTable';

function* sagaNewFilterContaAgrare(action) {
  try {
    yield put({ type: NEW_FILTER_CONTA_AGRARE_PEDING });
    
    let user = JSON.parse(storage.get(path.sessionUser));
    let where = `?clienteWhiteLabel_identificationCode=${user.identificationCodeWhiteLabel}${user.idPartnerWhiteLabel == null ? '' : `&partnerWhiteLabel=${user.idPartnerWhiteLabel}`}`;
    let filterSaved = sessionStorage.getItem(CONST_FILTER_CONTA_AGRARE) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_CONTA_AGRARE)) : null;
    
    let newFilter = {
      // Campos básicos
      nomeConta: '',
      accountCode: '',
      status: "S",
      licencaEmTeste: '',
      
      // Campos adicionais do filtro completo
      atividadeAgricola: '',
      objetivoProdutor: '',
      nomeResponsavelConta: '',
      emailPrincipal: '',
      dataCriacaoInicial: '',
      dataCriacaoFinal: '',
      dataFimTesteInicial: '',
      dataFimTesteFinal: '',
      dataUltAcessoInicial: '',
      dataUltAcessoFinal: '',
      
      // Controles de paginação
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: where,
    };

    if (filterSaved === null || filterSaved === undefined) {
      // Primeiro acesso - filtro padrão
      where += '&status=true';
      newFilter = {
        ...newFilter,
        where: where
      };
    } else {
      // Aplica filtro manual ou recupera filtro salvo
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        // mas mantém o número de registros por página selecionado pelo usuário
        newFilter.page = 0;
        
        // Filtro status (obrigatório)
        where += `&status=${action.args.status === 'S' ? true : false}`;
        
        // Filtro licença em teste
        if (action.args.licencaEmTeste !== null && action.args.licencaEmTeste !== undefined && action.args.licencaEmTeste !== '') {
          where += `&licencaEmTeste=${action.args.licencaEmTeste === 'S' ? true : false}`;
        }
        
        // Filtro nome da conta
        if (action.args.nomeConta !== null && action.args.nomeConta !== undefined && action.args.nomeConta !== '') {
          where += '&nomeConta=' + encodeURIComponent(action.args.nomeConta);
        }

        if (action.args.accountCode !== null && action.args.accountCode !== undefined && action.args.accountCode !== '') {
          where += '&accountCode=' + encodeURIComponent(action.args.accountCode);
        }
        
        // Filtro atividade agrícola
        if (action.args.atividadeAgricola !== null && action.args.atividadeAgricola !== undefined && action.args.atividadeAgricola !== '') {
          where += '&atividadeAgricola=' + encodeURIComponent(action.args.atividadeAgricola);
        }
        
        // Filtro objetivo produtor
        if (action.args.objetivoProdutor !== null && action.args.objetivoProdutor !== undefined && action.args.objetivoProdutor !== '') {
          where += '&objetivoProdutor=' + encodeURIComponent(action.args.objetivoProdutor);
        }

        if (action.args.nomeResponsavelConta !== null && action.args.nomeResponsavelConta !== undefined && action.args.nomeResponsavelConta !== '') {
          where += '&nomeResponsavelConta=' + encodeURIComponent(action.args.nomeResponsavelConta);
        }

        if (action.args.emailPrincipal !== null && action.args.emailPrincipal !== undefined && action.args.emailPrincipal !== '') {
          where += '&emailPrincipal=' + encodeURIComponent(action.args.emailPrincipal);
        }
        
        // Filtros de data de criação
        if ((action.args.dataCriacaoInicial !== null && action.args.dataCriacaoInicial !== undefined && action.args.dataCriacaoInicial !== '') ||
            (action.args.dataCriacaoFinal !== null && action.args.dataCriacaoFinal !== undefined && action.args.dataCriacaoFinal !== '')) {
          const dataInicialFormatted = action.args.dataCriacaoInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataCriacaoInicial)) : '';
          const dataFinalFormatted = action.args.dataCriacaoFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataCriacaoFinal)) : '';
          where += '&rangeDataCriacao=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }
        
        // Filtros de data fim do teste
        if ((action.args.dataFimTesteInicial !== null && action.args.dataFimTesteInicial !== undefined && action.args.dataFimTesteInicial !== '') ||
            (action.args.dataFimTesteFinal !== null && action.args.dataFimTesteFinal !== undefined && action.args.dataFimTesteFinal !== '')) {
          const dataInicialFormatted = action.args.dataFimTesteInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataFimTesteInicial)) : '';
          const dataFinalFormatted = action.args.dataFimTesteFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataFimTesteFinal)) : '';
          where += '&rangeDataFimTeste=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }
        
        // Filtros de data último acesso
        if ((action.args.dataUltAcessoInicial !== null && action.args.dataUltAcessoInicial !== undefined && action.args.dataUltAcessoInicial !== '') ||
            (action.args.dataUltAcessoFinal !== null && action.args.dataUltAcessoFinal !== undefined && action.args.dataUltAcessoFinal !== '')) {
          const dataInicialFormatted = action.args.dataUltAcessoInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataUltAcessoInicial)) : '';
          const dataFinalFormatted = action.args.dataUltAcessoFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(action.args.dataUltAcessoFinal)) : '';
          where += '&rangeDataUltAcesso=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          where: where
        };
      } else {
        // Recupera filtro salvo
        where += `&status=${filterSaved.status === 'S' ? true : false}`;
        
        // Aplica filtros salvos
        if (filterSaved.licencaEmTeste !== null && filterSaved.licencaEmTeste !== undefined && filterSaved.licencaEmTeste !== '') {
          where += `&licencaEmTeste=${filterSaved.licencaEmTeste === 'S' ? true : false}`;
        }
        
        if (filterSaved.nomeConta !== null && filterSaved.nomeConta !== undefined && filterSaved.nomeConta !== '') {
          where += '&nomeConta=' + encodeURIComponent(filterSaved.nomeConta);
        }

        if (filterSaved.accountCode !== null && filterSaved.accountCode !== undefined && filterSaved.accountCode !== '') {
          where += '&accountCode=' + encodeURIComponent(filterSaved.accountCode);
        }
        
        if (filterSaved.atividadeAgricola !== null && filterSaved.atividadeAgricola !== undefined && filterSaved.atividadeAgricola !== '') {
          where += '&atividadeAgricola=' + encodeURIComponent(filterSaved.atividadeAgricola);
        }
        
        if (filterSaved.objetivoProdutor !== null && filterSaved.objetivoProdutor !== undefined && filterSaved.objetivoProdutor !== '') {
          where += '&objetivoProdutor=' + encodeURIComponent(filterSaved.objetivoProdutor);
        }

        if (filterSaved.nomeResponsavelConta !== null && filterSaved.nomeResponsavelConta !== undefined && filterSaved.nomeResponsavelConta !== '') {
          where += '&nomeResponsavelConta=' + encodeURIComponent(filterSaved.nomeResponsavelConta);
        }

        if (filterSaved.emailPrincipal !== null && filterSaved.emailPrincipal !== undefined && filterSaved.emailPrincipal !== '') {
          where += '&emailPrincipal=' + encodeURIComponent(filterSaved.emailPrincipal);
        }
        
        if ((filterSaved.dataCriacaoInicial !== null && filterSaved.dataCriacaoInicial !== undefined && filterSaved.dataCriacaoInicial !== '') ||
            (filterSaved.dataCriacaoFinal !== null && filterSaved.dataCriacaoFinal !== undefined && filterSaved.dataCriacaoFinal !== '')) {
          const dataInicialFormatted = filterSaved.dataCriacaoInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataCriacaoInicial)) : '';
          const dataFinalFormatted = filterSaved.dataCriacaoFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataCriacaoFinal)) : '';
          where += '&rangeDataCriacao=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }
        
        if ((filterSaved.dataFimTesteInicial !== null && filterSaved.dataFimTesteInicial !== undefined && filterSaved.dataFimTesteInicial !== '') ||
            (filterSaved.dataFimTesteFinal !== null && filterSaved.dataFimTesteFinal !== undefined && filterSaved.dataFimTesteFinal !== '')) {
          const dataInicialFormatted = filterSaved.dataFimTesteInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataFimTesteInicial)) : '';
          const dataFinalFormatted = filterSaved.dataFimTesteFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataFimTesteFinal)) : '';
          where += '&rangeDataFimTeste=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }
        
        if ((filterSaved.dataUltAcessoInicial !== null && filterSaved.dataUltAcessoInicial !== undefined && filterSaved.dataUltAcessoInicial !== '') ||
            (filterSaved.dataUltAcessoFinal !== null && filterSaved.dataUltAcessoFinal !== undefined && filterSaved.dataUltAcessoFinal !== '')) {
          const dataInicialFormatted = filterSaved.dataUltAcessoInicial ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataUltAcessoInicial)) : '';
          const dataFinalFormatted = filterSaved.dataUltAcessoFinal ? formatDateDDMMYYYY(formatDateYYYYMMDD(filterSaved.dataUltAcessoFinal)) : '';
          where += '&rangeDataUltAcesso=' + dataInicialFormatted + '_' + dataFinalFormatted;
        }

        newFilter = {
          ...filterSaved,
          where: where
        };
      }
    }

    let list = yield call(listContaAgrare, user.id, `${where}&page=${newFilter.page}&size=${newFilter.rows}`);
    
    sessionStorage.setItem(CONST_FILTER_CONTA_AGRARE, JSON.stringify(newFilter));
    
    yield put({
      type: NEW_FILTER_CONTA_AGRARE_SUCCESS, 
      list: list, 
      filter: newFilter
    });
  } catch (e) {
    console.error('Erro no sagaNewFilterContaAgrare:', e);
    yield put({ type: NEW_FILTER_CONTA_AGRARE_FAILURE });
  }
}

export default function* watchNewFilterContaAgrare() {
  yield takeLatest(NEW_FILTER_CONTA_AGRARE, sagaNewFilterContaAgrare);
}
